import type { ApolloError } from '@apollo/client';
import { user_select_column } from '../lib/generated/zeus';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { genericScalars } from '../lib/graphql/helpers';

const queryUserDistinctTypesName = 'queryUserDistinctTypes';

/**
 * Query user distinct types.
 */
const useQueryUsersTypes = (
  onError: (e: ApolloError) => void,
  onCompleted?: (d: readonly string[]) => void
) =>
  useTypedQuery(
    {
      user: [
        {
          distinct_on: [user_select_column.user_type],
        },
        {
          user_type: true,
        },
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: {
        onCompleted: (data) => {
          if (onCompleted !== undefined) {
            const queriedUserTypes: readonly string[] = data.user
              .map((user) =>
                // Hasura will return null value even it is not defined in its type.
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                user.user_type === null ? 'NULL' : user.user_type
              )
              .filter(
                (user_type): user_type is string => user_type !== undefined
              );
            onCompleted(queriedUserTypes);
          }
        },
        onError,
      },
      operationOptions: { operationName: queryUserDistinctTypesName },
    }
  );

export default useQueryUsersTypes;
